export default __webpack_public_path__ + "static/img-channel-heading-pc-ea2dfde4c74a2b205b95fbd439e27721.png";